module.exports = __webpack_public_path__ + "static/mustardwaffle-bf55b7fb39d6d59997ec0da61d09afb2.jpeg";